import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-call-to-action-cell',
    template: `
        <div [ngStyle]="{'display': (showWarnIcon) ? 'flex' : 'inline', 'justify-content': 'space-between'}">            
        <a calltoaction
          class="{{calltoactionclass}}"
          [calltoactionTemplate]="params.getTemplate(params)"
          [calltoactionUsesHover]="calltoactionUsesHover"
          [calltoactionMaxWidth]="calltoactionMaxWidth"
          [calltoactionPosition]="calltoactionPosition"
          [calltoactionUseTruncationParent]="calltoactionUseTruncationParent"
          [calltoactionHorizontalOffset]='calltoactionHorizontalOffset'>
                <span *ngIf="hasValue" (click)="callactionClick()">{{params.value}}</span>
                <div *ngIf="params.icon === 'delete'" class='btn-action-close-delete'></div>
            </a>
            <span *ngIf="showWarnIcon" class="icon-warning" style="background-position-x: right; line-height: 30px;"
                calltoaction [calltoactionTemplate]="params.getWarnIconTemplate(params)" calltoactionPosition="right" [calltoactionUsesHover]="true"></span>
        </div>
        `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallToActionCellComponent implements AgRendererComponent {
    params: any;
    calltoactionUsesHover: boolean;
    calltoactionPosition: string;
    calltoactionMaxWidth: string;
    calltoactionclass: string;
    calltoactionHorizontalOffset: number;
    calltoactionUseTruncationParent: boolean;
    hasValue: boolean;
    showWarnIcon: boolean;

    constructor() {}

    agInit(params: any) {
        this.params = params;  
        this.calltoactionUsesHover = (this.params.calltoactionUsesHover) ? this.params.calltoactionUsesHover : false;
        this.calltoactionUseTruncationParent = (this.params.calltoactionUseTruncationParent) ? this.params.calltoactionUseTruncationParent : true;
        this.calltoactionPosition = (this.params.calltoactionPosition) ? this.params.calltoactionPosition : 'right';
        this.calltoactionMaxWidth = (this.params.calltoactionMaxWidth) ? this.params.calltoactionMaxWidth : '300px';
        this.calltoactionHorizontalOffset = (this.params.calltoactionHorizontalOffset) ? this.params.calltoactionHorizontalOffset : 0;
        this.calltoactionclass = this.params.calltoactionclass ? this.params.calltoactionclass(params) : '';
        this.showWarnIcon = this.params.showWarnIcon ? this.params.showWarnIcon(this.params) : false;

        if (this.params.valueFormatter) {
            this.params.value = this.params.valueFormatter(this.params);
        }

        this.hasValue = typeof params.value != 'undefined';
    }

    refresh(): boolean {
        return true;
    }

    callactionClick() {
        if (this.calltoactionclass === 'link-to-click' && this.params.calltoactionClick) {
            this.params.calltoactionClick(this.params);
        }
    }

}
